import { useAxios } from "apis/hooks/useAxios";
import { getApi } from "./util/getApi";

const fetchURL =
  "https://carefulqueen.backendless.app/api/services/PaymentService";

const api = getApi(fetchURL);

export const createPaymentIntent = (data: {
  stripeCustomerId: string;
  amount: number;
}) => api.post("/create-payment-intent", data).then((r) => r.data);

export const useCreatePaymentIntent = (data: {
  stripeCustomerId: string;
  amount: number;
}) => {
  return useAxios(fetchURL + "/create-payment-intent", {
    method: "POST",
    data,
  });
};

export const createSubscription = (data: {
  stripeCustomerId: string;
  priceId: string;
}) => api.post("create-subscription", data).then((r) => r.data);

export const useCreateSubscription = (data: {
  stripeCustomerId: string;
  priceId: string;
}) => {
  return useAxios(fetchURL + "/create-subscription", {
    method: "POST",
    data,
  });
};
